import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faHome } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import NotificationDropdown from "./NotificationDropdown";
import UserDropdown from "./UserDropdown";

const Navbar = ({ user, notifications, onLogout, onSearchChange }) => {
  const [search, setSearch] = useState("");
  const [fetchedNotifications, setFetchedNotifications] = useState(notifications || []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (onSearchChange) onSearchChange(value);
  };

  const fetchNotifications = async () => {
    if (!user?.idUtilisateur) return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/user/${user.idUtilisateur}/notifications`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Erreur lors de la récupération des notifications");
      const data = await response.json();
      setFetchedNotifications(data);
    } catch (error) {
      console.error("Erreur de notification:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 30000); // Refresh every 30 sec
    return () => clearInterval(interval);
  }, [user?.idUtilisateur]);

  if (!user) return null;

  const unreadCount = fetchedNotifications.filter((n) => !n.lu).length;

  return (
    <nav className="dashboard-nav-gradient text-white shadow-lg" style={{ width: "100%" }}>
      <div className="dashboard-nav-container">
        <div className="dashboard-logo-container">
          <div className="dashboard-logo-text">
            <span className="dashboard-wi">WI</span>
            <span className="dashboard-cv">CV</span>
          </div>
        </div>

        {/* Barre de recherche */}
        <div className="dashboard-search-container">
          <div className="dashboard-search-wrapper">
            <div className="dashboard-search-icon">
              <FontAwesomeIcon icon={faSearch} />
            </div>
            <input
              className="dashboard-search-input"
              placeholder="Rechercher un CV..."
              type="search"
              value={search}
              onChange={handleSearchChange}
            />
          </div>
        </div>

        <div className="dashboard-right-menu">
          <Link to="/dashboardUser" className="dashboard-home-btn">
            <FontAwesomeIcon icon={faHome} />
          </Link>
          <NotificationDropdown
            notifications={fetchedNotifications}
            unreadCount={unreadCount}
            setNotifications={setFetchedNotifications}
          />
          <UserDropdown
            user={user}
            initials={`${user.nom.charAt(0).toUpperCase()}${user.prenom.charAt(0).toUpperCase()}`}
            onLogout={onLogout}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
